import { SubmitButtonBase } from "@compass/core";
import { ButtonProps as MuiButtonProps } from "@mui/material";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const SubmitButton = (
  props: MuiButtonProps & {
    label?: ReactNode;
    disabled?: boolean;
  }
) => {
  const appLoading = useSelector((state: RootState) => state.app.loading);
  const disabledOnLoading = appLoading > 0; // submit button needs to be disabled when loading

  const { label, disabled, ...rest } = props;
  return <SubmitButtonBase label={label} disabled={disabledOnLoading || disabled} {...rest} />;
};
